import { render } from "./FormPhotoGeneralCars.vue?vue&type=template&id=9213af94"
import script from "./FormPhotoGeneralCars.vue?vue&type=script&lang=js"
export * from "./FormPhotoGeneralCars.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__